var unirest = require('unirest');

const API = require ('Api') ;



export async function getHolidays ( token, calendarID ) {

   const res =  await unirest.get(API.V2 + API.SCHOOLS + "holidays"  )
            .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseAttendance ( token, courseID, calendarID ) {

    // const res =  await unirest.get("http://0.0.0.0:3006/dev/courses/" + courseID  )
   const res =  await unirest.get(API.V2 + API.ATTENDANCE + "courses/" + courseID  )
            .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function postAttendance ( token, studentID, calendarID, data ) {
    console.log('PEPE',calendarID)
    const res =  await unirest.post(API.V2 + API.ATTENDANCE + "students/" + studentID   )
            .headers({'Authorization': 'Bearer ' + token , 'Content-Type': 'application/json', 'crrntcal':calendarID })
            .send(data);
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function deleteAttendance ( token, studentID, attendanceID ) {

    const res =  await unirest.delete(API.V2 + API.ATTENDANCE + "students/" + studentID + "/" + attendanceID  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getAttendanceTypes ( token  ) {
   const res =  await unirest.get(API.V2 + API.CONFIG + "attendancetypes" )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

// Statuses

export async function postCourseAttendanceStatus ( token, courseID, data ) {
    const res =  await unirest.post(API.V2 + API.ATTENDANCE + "courses/"+courseID+"/status" )
            .headers({'Authorization': 'Bearer ' + token , 'Content-Type': 'application/json'})
            .send(data);
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getCourseAttendanceStatus( token, courseID   ) {
    const res =  await unirest.get(API.V2 + API.ATTENDANCE + "courses/"+courseID+"/status" )
             .headers({'Authorization': 'Bearer ' + token });
            //  .query('month='+ month );
     if (res.error) console.log(res.error)
     let list = res.body ;
 return list ;
 }
